import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Stack,
} from '@mui/material';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DownloadIcon from '@mui/icons-material/Download';
import FAQList from '../components/common/FAQList';
import ContactButtons from '../components/common/ContactButtons';

const USER_MANUAL_URL = '/docs/client-portal-user-manual.pdf';

const FAQS = [
  {
    question: 'How do I apply for new loan account?',
    answer: 'To apply for loan account, click on "Apply for Loan" given on the Home Screen.'
  },
  {
    question: 'Where can I view my profile information?',
    answer: 'You can view your profile information by clicking on the User Image present on Home Screen.'
  },
  {
    question: 'Where can I see my Savings Accounts Transactions?',
    answer: 'To view your savings account transactions, navigate to the Accounts Sections, click on the required savings account, click on three dots present on top right and select Transactions option.'
  },
  {
    question: 'What is the use of QR Code?',
    answer: 'QR Code for any loan or savings accounts can be shared with other users for easy account identification and transfers.'
  },
  {
    question: 'How to make a payment for a Loan Account?',
    answer: 'To make a payment for a loan account, navigate to the Accounts Sections, choose LOAN then open your required Loan Account and click on Make Payment option.'
  },
];

const Help: React.FC = () => {
  return (
    <Box sx={{ p: 3, maxWidth: 700, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom>Help</Typography>

      <Card variant="outlined" sx={{ mb: 3 }}>
        <CardContent>
          <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1 }}>
            <MenuBookIcon color="primary" />
            <Typography variant="h6">Client Portal User Manual</Typography>
          </Stack>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Step-by-step guide for using the SMEDCO Client Portal — registration, loan applications,
            payments, and account management.
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
            <Button
              variant="contained"
              startIcon={<OpenInNewIcon />}
              href={USER_MANUAL_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              View Manual
            </Button>
            <Button
              variant="outlined"
              startIcon={<DownloadIcon />}
              href={USER_MANUAL_URL}
              download="SMEDCO-Client-Portal-User-Manual.pdf"
            >
              Download PDF
            </Button>
          </Stack>
        </CardContent>
      </Card>

      <FAQList faqs={FAQS} />

      <ContactButtons
        phoneNumber="+263-242-792822"
        emailAddress="enquiries@smedco.co.zw"
        locationsUrl="/locations"
      />
    </Box>
  );
};

export default Help;
